import { ReactElement } from 'react';
import { useField } from 'formik';

export type WithFormikProps<P, T> = P & { value: T; onChange: (value: T) => void };
export type WithFormikReturnType<P> = Omit<P, 'value' | 'onChange'> & { name: string };

export function withFormik<P, T>(
	component: (props: WithFormikProps<P, T>) => ReactElement,
): (props: WithFormikReturnType<P>) => ReactElement {
	const WithFormik = (props: WithFormikReturnType<P>) => {
		const { name, ...rest } = props;
		const [{ value }, , { setValue, setTouched }] = useField(name);

		const Component = component;

		return (
			// @ts-expect-error: This was already like this, so we accept the possibility
			// P' could be instantiated with an arbitrary type which could be unrelated to 'Omit, "name"> & { value: any; onChange: (value: T) => void; onBlur: () => void; }
			<Component
				{...rest}
				value={value}
				onChange={(value) => {
					setValue(value);
				}}
				onBlur={() => {
					setTouched(true);
				}}
			/>
		);
	};

	WithFormik.displayName = 'withFormikDisplayName';

	return WithFormik;
}
